import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSearchPageShowNoProductResults } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageShowNoProductResults";

export const useSearchPageShouldNotShowAnyFiltersForLoggedIn = () => {
  const {
    data: { activeFilterCount },
  } = useFilterStore(["activeFilterCount"]);

  const showNoSearchResultsContainer = useSearchPageShowNoProductResults();

  return (
    showNoSearchResultsContainer &&
    activeFilterCount === 0 &&
    isLoggedInRetailer()
  );
};
